import c from '../colors';
/**
 * @see http://livingston.sas.com/10-0/essentials/focus/
 */
export const stateFocus = {
  onLightBg(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          bd: c.hcFocus(theme),
          bdStyle: 'dotted',
          bdWidth: '5px'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bd: c.p1(theme),
          bdStyle: 'dotted',
          bdWidth: '1px'
        };
      case 'high-contrast':
        return {
          bd: c.colorTextPrimary(theme),
          bdStyle: 'dotted',
          bdWidth: '5px'
        };
      default:
        return {
          bd: c.p_1(theme),
          bdStyle: 'dotted',
          bdWidth: '1px'
        };
    }
  },
  // The Accessibility form under Settings dialog in particular always needs them.
  default(theme) {
    return this.onLightBg(theme);
  },
  onDarkBg(theme) {
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bd: c.p1(theme),
          bdStyle: 'dotted',
          bdWidth: '1px'
        };
      case 'high-contrast':
        return {
          bd: c.black(theme),
          bdStyle: 'dotted',
          bdWidth: '5px'
        };
      default:
        return {
          bd: c.white(theme),
          bdStyle: 'dotted',
          bdWidth: '1px'
        };
    }
  },
  onRightClick(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          bd: c.hcFocus(theme),
          bdStyle: 'dotted',
          bdWidth: '5px'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bd: c.p1(theme),
          bdStyle: 'solid',
          bdWidth: '1px'
        };
      case 'high-contrast':
        return {
          bd: c.colorTextPrimary(theme),
          bdStyle: 'solid',
          bdWidth: '5px'
        };
      default:
        return {
          bd: c.p_1(theme),
          bdStyle: 'solid',
          bdWidth: '1px'
        };
    }
  }
};

/**
 * Temporary doc until the new Design System site is up
 * @see https://gitlab.sas.com/novacommons/nova-tokens/-/tree/master/tokens
 */
export const stateFocusNova = {
  onLightBg(theme) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return {
          bd: c.colorTextPrimary(theme),
          bdStyle: 'dotted',
          bdWidth: '4px'
        };
      default:
        return {
          bd: c.colorTextPrimary(theme),
          bdStyle: 'dotted',
          bdWidth: '1px'
        };
    }
  },
  // The default is added so that these are always present in the designTokens obtained through useDesignTokens().
  // The Accessibility form under Settings dialog in particular always needs them.
  default(theme) {
    return this.onLightBg(theme);
  },
  onDarkBg(theme) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return {
          bd: c.colorTextInverse(theme),
          bdStyle: 'dotted',
          bdWidth: '4px'
        };
      default:
        return {
          bd: c.colorTextInverse(theme),
          bdStyle: 'dotted',
          bdWidth: '1px'
        };
    }
  },
  onRightClick(theme) {
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return {
          bd: c.colorTextPrimary(theme),
          bdStyle: 'solid',
          bdWidth: '4px'
        };
      default:
        return {
          bd: c.colorTextPrimary(theme),
          bdStyle: 'solid',
          bdWidth: '1px'
        };
    }
  }
};
//# sourceMappingURL=focus.js.map